import axios from 'axios';
import { addResponseInterceptor } from './config';

const axiosInstance = axios.create({
  withCredentials: true,
  allow_headers: ['Content-Type', 'Authorization', 'locale'],
  headers: {
    locale: localStorage.getItem("locale") || 'en',
    "Avatar-Type": localStorage.getItem("Avatar-Type"),
    "Avatar-Guid": localStorage.getItem("Avatar-Guid"),
    "User-Full-Name": localStorage.getItem("User-Full-Name"),
  }
});

addResponseInterceptor(axiosInstance);

export {
  axiosInstance
};